import React from 'react';
import axios from 'axios';
import {API_URL} from '../../utils/axios';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import './VoteOptions.scss';
import YelpIcon from '../../assets/icons/yelp.svg';
import PhoneIcon from '../../assets/icons/phone-call.svg';
import StarIcon from '../../assets/icons/star.svg';
import MapIcon from '../../assets/icons/map.svg';
import HourglassIcon from '../../assets/icons/hourglass.svg';

const VoteOptions = ({pollOptions, endDateTimeText, pin, setThankyoumessage, thankyoumessage}) => {
  
    const handleSubmit = (e) => {
        e.preventDefault();
        axios.defaults.headers['foodrtoken'] = localStorage.getItem("token");
        axios.post(API_URL + "/poll/pin/" + pin, {
            voteOption: e.target.vote.value
        }).then((response) => {
    console.log(response.data)
    setThankyoumessage(true)
        }).catch(error => console.log(error))
    }
    return (
        <div className="vote-option">
            {!thankyoumessage && <form onSubmit={handleSubmit}> 
                <div className="vote-option__container">
                <Accordion allowZeroExpanded>
                        {pollOptions && pollOptions.map((poll) => {
                        
                        return <AccordionItem key={poll._id} className="vote-option__accordian">
                            <AccordionItemHeading>
                                <AccordionItemButton >
                                    <div className="vote-option__top-container">
                                        <div className="vote-option__radio-container">
                                            <input type="radio"
                                                name="vote"
                                                value={JSON.stringify(poll)}
                                                className="vote-option__input"/> 
                                        </div>
                                        <div className="vote-option__label-container"> 
                                            <label className="vote-option__label">{poll.value.label}</label>
                                        </div>
                                    </div>
                                    <div className="vote-option__yelp-container">
                                        <a href={poll.value.url} target="_blank"><img src={YelpIcon} className="vote-option__icon" alt="yelpIcon"></img></a>
                                    </div>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel class="vote-option__drop-panel">
                                <div className="vote-option__drop-container">
                                    <div className="vote-option__drop-phone-container">
                                        <img className="vote-option__sub-icon" src={PhoneIcon} alt="phoneIcon"></img>
                                        <p className="vote-option__drop-text">{poll.value.phone}</p>
                                    </div>
                                    <div className="vote-option__drop-rating-container">
                                        <img className="vote-option__sub-icon" src={StarIcon} alt="starIcon"></img>
                                        <p className="vote-option__drop-text">{poll.value.rating} / 5</p>
                                    </div>
                                    <div className="vote-option__drop-address-container">
                                        <img className="vote-option__sub-icon" src={MapIcon} alt="addressIcon"></img>
                                        <p className="vote-option__drop-text">{poll.value.display_address_0} {poll.value.display_address_1}</p>
                                    </div>
                                </div> 
                                </AccordionItemPanel>
                        </AccordionItem>
                        })}
                        </Accordion>
                </div>
                <button className="vote-option__button">Submit Vote</button>
            </form>}
            {thankyoumessage && <div className="vote-option__post-message-container">
                <p className="vote-option__post-message">Thank you for your response. </p>
                <p className="vote-option__post-message-results">The results will be available on {endDateTimeText}</p>
                <img className="vote-option__post-message-icon" src={HourglassIcon} alt="hourglass"></img>
            </div>}
           
        </div>
    );
};

export default VoteOptions;